function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  transform: "matrix(1 0 0 -1 0 864)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M510 124c31 0 57 -11 79 -33s33 -48 33 -79s-11 -57 -33 -79s-48 -33 -79 -33s-57 11 -79 33s-33 48 -33 79s11 57 33 79s48 33 79 33zM507 605l3 3c-31 0 -57 11 -79 33s-33 45 -33 70s5 46 15 63s23 30 40 40s38 15 63 15s48 -11 70 -33s33 -48 33 -79s-11 -57 -33 -79 s-48 -33 -79 -33zM448 456l3 3c17 10 38 15 63 15s48 -11 70 -33s33 -48 33 -79s-11 -57 -33 -79s-48 -33 -79 -33s-57 11 -79 33s-33 45 -33 70s5 46 15 63s23 30 40 40z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: 1.1,
    viewBox: "0 0 1008 1008"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/three-dots-vertical.46349b9a.svg";
export { SvgComponent as ReactComponent };